// FileView.jsx

import React from 'react';

// Components
import MediaDownloadFallback from 'node/media/MediaDownloadFallback';

/**
 * FileView
 *
 * Generic FILE nodes are not previewable in-app — show a download affordance.
 *
 * @param {object} node - The file node to display.
 *
 * @returns {ReactNode} The rendered file feed node or null if invalid input.
 */
const FileView = ({ node }) => {
    if (!node) return null;
    return <MediaDownloadFallback node={node} />;
};

// Dev Tools
FileView.displayName = 'FileView';

export default FileView;
